import { render, staticRenderFns } from "./HighValueReportBody.vue?vue&type=template&id=388055b7&scoped=true&"
import script from "./HighValueReportBody.vue?vue&type=script&lang=ts&"
export * from "./HighValueReportBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388055b7",
  null
  
)

export default component.exports